import { render, staticRenderFns } from "./LadiesMinistry.vue?vue&type=template&id=635bb050&"
import script from "./LadiesMinistry.vue?vue&type=script&lang=js&"
export * from "./LadiesMinistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports